module.exports = __webpack_public_path__ + "assets/omnisend.8ba86cdc.svg";